// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, doc, getDoc } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB_q_tr0ZJRcMDWM8hucCeG2V8SAa9w7ME",
  authDomain: "gamebase-1595e.firebaseapp.com",
  databaseURL: "https://gamebase-1595e.firebaseio.com",
  projectId: "gamebase-1595e",
  storageBucket: "gamebase-1595e.firebasestorage.app",
  messagingSenderId: "262667635588",
  appId: "1:262667635588:web:bb1854b96b4bc11449abd1",
  measurementId: "G-1V4VLHVRT8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export {
  db,
  collection,
  getDocs,
  doc,
  getDoc,
  auth,
  signInWithGoogle,
  signOut,
  onAuthStateChanged,
}; // ✅ adicione aqui
